export const HSNsearch_config = [
  "a4",
  "a4-copier-paper",
  "a-4-paper",
  "a4-size-papaer",
  "acp-sheets",
  "acrylic",
  "alienware-17-r5",
  "all-drin",
  "allen-bolts",
  "all-oxygen-concentrator",
  "aluminium-extru",
  "aluminium-fabrication-works",
  "aluminium-ingot",
  "aluminium-partition-work",
  "aluminium-rivit",
  "alu-partition",
  "audit-fee",
  "audit-professional-services",
  "balloon-holi",
  "bamboo-and-broom",
  "banan-chips",
  "bank-charges-9971",
  "bar-soap",
  "beauty-parlour-products",
  "bimat-eye-drops",
  "bolied-coffee",
  "bolt-m16",
  "bottle-of-anodyne",
  "brass-pictures",
  "brp020",
  "bthrottle-with-handgrip",
  "buffalo-ear",
  "building-construction-work",
  "building-material-sand",
  "bullet-camers",
  "business-cardm-holder",
  "business-promotional-events",
  "c-45-material",
  "cable-lug",
  "cardamom09083190",
  "cat6-cable",
  "cat-6-cable",
  "cat6-patch-cord",
  "cc-camera",
  "c-channel",
  "cctv-c",
  "cctv-video-balun",
  "celinf-fan",
  "ceramic-products",
  "chanachur",
  "chips-kurkure",
  "cleaning-items",
  "cleaning-products",
  "coir-products",
  "confectionery-items",
  "construction-of-building",
  "cot",
  "cotton-bag",
  "cotton-bed-sheet",
  "cotton-dress-material",
  "cotton-hand-gloves",
  "cotton-line-dori",
  "cotton-shirts",
  "count-of-medicine",
  "crane-spare-parts",
  "crush-sand",
  "cutting-tools",
  "desktop-pc",
  "discount-on-sales",
  "dm-water",
  "dress-material",
  "drum",
  "dry-fruits",
  "earthing-material",
  "earthing-materials",
  "electrical-items-pdf",
  "electrical-material",
  "electrical-materials",
  "electrical-works",
  "electric-items",
  "eot-crane-spares",
  "epoxy-flooring-service",
  "epson-l3110",
  "e-rickshaw",
  "extended-warranty",
  "false-ceiling-work",
  "fan",
  "farsan-and-namkeen",
  "find-medicine",
  "flat-sale",
  "flipkart-legging",
  "formal-shirts",
  "formal-shoes",
  "frp-products",
  "furniture-and-fixtures",
  "garden-maintenance-services",
  "generator-rental-services",
  "gi-bucket",
  "gi-elbow",
  "gi-flat",
  "gi-pipe",
  "gi-sheet",
  "gi-strip",
  "gold-and-silver",
  "gold-coins",
  "greeting-cards",
  "grocery-products",
  "hair-clips",
  "handloom-products",
  "hardware-material",
  "health-mix",
  "heater-element",
  "hikvision-camera",
  "holi-colour",
  "hp-cartridge",
  "hp-laptop",
  "hr-sheet",
  "httpswwwdripcapitalcomhts-codesearchbooks",
  "i-beam",
  "id-cards",
  "installation-services",
  "instant-mix",
  "j-hook",
  "job-work-9988",
  "keyboard-mouse",
  "khadi-products",
  "kirana-goods",
  "kirana-shop",
  "kirana-store",
  "label-sticker",
  "laboratory-equipments",
  "lace-fabric",
  "ladies-tops",
  "laminar-air-flow",
  "land-sale",
  "laptop-bags",
  "lays-chips",
  "l-clamp",
  "leather-bags",
  "leather-hand-gloves",
  "leather-products",
  "leather-wallets",
  "lifebuoy-soap",
  "liquid-hand-wash",
  "liquid-soap",
  "machine-repair",
  "machinery-spares",
  "machine-spare-parts",
  "maintenance-services",
  "mandap-keeper-service",
  "marble-and-granite",
  "marble-handicrafts",
  "masala-items",
  "masala-products",
  "mens-wear-jeans",
  "mill-scale",
  "miscellaneous-income",
  "miscellaneous-items",
  "mobil-oil",
  "mosquito-bat",
  "motor-parts",
  "mouse-and-keyboard",
  "m-sand",
  "ms-angle",
  "ms-bar",
  "ms-beam",
  "ms-bolt",
  "ms-box",
  "ms-bracket",
  "ms-bush",
  "ms-clamp",
  "ms-clamps",
  "m-seal",
  "ms-elbow",
  "ms-fittings",
  "ms-flange",
  "ms-flanges",
  "ms-flat-bar",
  "ms-gate",
  "ms-grill",
  "ms-jali",
  "ms-material",
  "ms-nut-bolt",
  "ms-petrol",
  "ms-pipe",
  "ms-pipe-fabrication",
  "ms-plate",
  "ms-rack",
  "ms-rod",
  "ms-round-bar",
  "ms-scrap",
  "ms-shaft",
  "ms-square-bar",
  "ms-stand",
  "ms-structure",
  "ms-tank",
  "ms-trolley",
  "ms-tube",
  "ms-washer",
  "nc-thinner",
  "nuts",
  "oils",
  "old-car-sale",
  "old-dhoti",
  "old-machinery",
  "o-ring",
  "other-charges",
  "packing-forwarding",
  "packing-forwarding-charges",
  "painting-works-contract",
  "pant-and-shirt",
  "paper-cups",
  "paper-plates",
  "pa-system",
  "patanjali-products",
  "peb-structure",
  "photography-services",
  "photography-videography",
  "plants-and-trees",
  "plastic-articles",
  "plastic-items",
  "plastic-pallets",
  "plates",
  "plug-gauges",
  "poly-bags",
  "polycab-cable",
  "polycab-wire",
  "polyester-spun-yarn",
  "pooja-items",
  "pooja-material",
  "pop-work",
  "porta-cabin",
  "posters",
  "pot",
  "poultry-feed-supplements",
  "pp-bags",
  "pp-rope",
  "pp-sheet",
  "provisional-items",
  "provision-items",
  "pu-foam-sheet",
  "pu-footwear",
  "pu-leather",
  "pulses-and-grams",
  "pu-pipe",
  "pvc-products",
  "r22-gas",
  "racks",
  "remote",
  "resin-products",
  "rg6-cable",
  "right-angle",
  "rj45-connector",
  "roll-up-standee",
  "rubber-o-ring",
  "rubber-o-rings",
  "safety-jackets",
  "sale-of-car",
  "sale-of-land",
  "sand-stone",
  "saree-business",
  "scaffolding-pipes",
  "scotch-brite-pad",
  "seo-services",
  "services-charges",
  "servo-voltage-stabilizer",
  "shawls",
  "siddha-medicine",
  "smart-phones",
  "smart-watches",
  "social-media-marketing",
  "solder-wire",
  "soya-badi",
  "soya-bari",
  "ss-304-plate",
  "ss-circle",
  "ss-fabricated-items",
  "ss-fabrication",
  "ss-fabrication-work",
  "ss-fittings",
  "ss-flanges",
  "ss-material",
  "ss-nut-bolt",
  "ss-plate",
  "ss-railing",
  "ss-scrap",
  "ss-storage-tank",
  "ss-table",
  "ss-tank",
  "ss-tray",
  "ss-trolley",
  "ss-wire",
  "stationery-products",
  "stationery-shop",
  "steel-fabrication-work",
  "stickers",
  "stock-brokers",
  "submersible-pumps",
  "submersible-water-pump",
  "suits",
  "sweet-shop",
  "tap",
  "taparia-cutting-plier",
  "taparia-tools",
  "tea-and-coffee",
  "tea-coffee",
  "til",
  "titan-watch-9102",
  "toilet",
  "toll-tax",
  "toner-cartridge-refilling",
  "tools-and-tackles",
  "track-pants",
  "trade-discount",
  "trading-of-goods",
  "transport-charges-rcm",
  "trousers-shirt-tie",
  "turnkey-projects",
  "u-clamp",
  "u-jack",
  "ultratech-cement",
  "unani-medicine",
  "uniform-clothes",
  "unstitched-ladies-suit",
  "used-car",
  "vim-liquid",
  "wall-mounted-fan",
  "wastewater-treatment-plant",
  "water-tanker-supply",
  "water-treatment-chemicals",
  "water-treatment-plant",
  "wd-40",
  "wd-40-spray",
  "weighing-scale",
  "weight-machine",
  "welding-black-glass",
  "welding-electrodes",
  "white-board-marker",
  "wholesale-medicine-business",
  "wind-power-generation",
  "wooden-handicraft-items",
  "wooden-pattern",
  "batte-r-y",
];

export default HSNsearch_config;
